import type { ValidationConfig } from "@/components/units/MediaUploader/mediaStore";

export enum EntityType {
  BRANCH = "BRANCH",
  MENU = "MENU",
  DISH = "DISH",
}

export const AmenitiesType = {
  FACILITIES: "AMENITY_FACILITIES",
  KIDS: "AMENITY_KIDS",
  CROWD: "AMENITY_CROWD",
  ENTERTAINMENT: "AMENITY_ENTERTAINMENT",
  PARKING: "AMENITY_PARKING",
  DINING: "AMENITY_DINING",
  PAYMENT: "AMENITY_PAYMENT",
  OTHER: "AMENITY_OTHER",
} as const;

export type AmenitiesType = (typeof AmenitiesType)[keyof typeof AmenitiesType];

export const isAmenityType = (type: string) =>
  Object.values(AmenitiesType).includes(type as AmenitiesType);

export const AttributeType = {
  CUISINE: "CUISINE",
  MOMENT: "MOMENT",
  TAG: "TAG",
  ALLERGEN: "ALLERGEN",
  DRESS_CODE: "DRESS_CODE",
  DIET: "DIET",
  AMBIANCE: "AMBIANCE",
  MIEL_TIME: "MEAL_TIME",
  DISH_CATEGORY: "DISH_CATEGORY",
  OCCASION: "OCCASION",
  CUISINES_MENU: "CUISINES_MENU",
  FLAG_AND_STATUS: "FLAG_AND_STATUS",

  ...AmenitiesType,
} as const;

export type AttributeType = (typeof AttributeType)[keyof typeof AttributeType];

export const BRANCH_ATTRIBUTES_CONFIG: readonly {
  type: AttributeType;
  title: string;
}[] = [
  { type: AttributeType.TAG, title: "Tags" },
  { type: AttributeType.AMBIANCE, title: "Ambiance" },
  { type: AttributeType.DRESS_CODE, title: "Dress code" },
  { type: AttributeType.MOMENT, title: "Moments" },
  { type: AttributeType.CUISINE, title: "Cuisines" },
  { type: AttributeType.FACILITIES, title: "Facilities" },
  { type: AttributeType.KIDS, title: "Kids" },
  { type: AttributeType.CROWD, title: "Crowd" },
  { type: AttributeType.ENTERTAINMENT, title: "Entertainment" },
  { type: AttributeType.PARKING, title: "Parking" },
  { type: AttributeType.DINING, title: "Dining" },
  { type: AttributeType.PAYMENT, title: "Payment" },
  { type: AttributeType.OTHER, title: "Other" },
];

export const getBranchAttributeLabel = (type: string): string =>
  BRANCH_ATTRIBUTES_CONFIG.find(attribute => attribute.type === type)?.title ??
  type;

export interface PropertyFillterParams {
  scope?: EntityType;
  type?: AttributeType;
  search?: string;
}

export interface IProperty {
  id: string;
  type: AttributeType;
  scope: EntityType;
  nameEn: string;
  nameAr: string;
  slug: string;
  order: number;
  processedMediaId: string | null;
  mediaName: string | null;
  imageUrl: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface InfoProperty {
  type: AttributeType;
  scope: EntityType;
  nameEn: string;
  nameAr?: string | null;
  order?: number;
  iconUrl?: string;
  mediaId?: string | null | undefined;
}

export const PROPERTY_ICON_ACCEPTED_TYPES = {
  "image/svg+xml": [".svg"],
};

export const PropertyIconValidation: ValidationConfig = {
  vector: {
    acceptedMimeTypes: Object.keys(PROPERTY_ICON_ACCEPTED_TYPES),
    maxSize: 1 * 1024 * 1024,
    minSize: 1,
    dimensionConstraints: {
      minWidth: 40,
      minHeight: 40,
      maxWidth: 40,
      maxHeight: 40,
    },
  },
  limits: {
    maxVideos: 0,
    maxImages: 1,
  },
  logotypeDimensionConstraints: {
    minWidth: 40,
    minHeight: 40,
    maxWidth: 40,
    maxHeight: 40,
  },
};
